export function imagesTransformation(getEnhancedProductData, imagesFrom) {
  if (
    getEnhancedProductData &&
    getEnhancedProductData.SelectedSku &&
    getEnhancedProductData.SelectedSku.Images != null &&
    getEnhancedProductData.SelectedSku.Images.Thumbs.length > 0
  ) {
    let allImages = getEnhancedProductData.SelectedSku.Images;

    if (
      getEnhancedProductData.Series &&
      getEnhancedProductData.Series.Videos != null &&
      getEnhancedProductData.Series.Videos.Thumbs.length > 0
    ) {
      // Large Size
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.LargeSize.length;
        i++
      ) {
        allImages.LargeSize.push(
          getEnhancedProductData.Series.Videos.LargeSize[i]
        );
      }
      // Thumbs
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.Thumbs.length;
        i++
      ) {
        allImages.Thumbs.push(getEnhancedProductData.Series.Videos.Thumbs[i]);
      }

      // Normal Size
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.NormalSize.length;
        i++
      ) {
        allImages.NormalSize.push(
          getEnhancedProductData.Series.Videos.NormalSize[i]
        );
      }

      // Medium Size
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.MediumSize.length;
        i++
      ) {
        allImages.MediumSize.push(
          getEnhancedProductData.Series.Videos.MediumSize[i]
        );
      }
    }

    for (let i = 0; i < allImages.Thumbs.length; i++) {
      allImages.Thumbs[i].id = i;
    }
    for (let i = 0; i < allImages.NormalSize.length; i++) {
      allImages.NormalSize[i].id = i;
    }
    for (let i = 0; i < allImages.LargeSize.length; i++) {
      allImages.LargeSize[i].id = i;
    }
    for (let i = 0; i < allImages.MediumSize.length; i++) {
      allImages.MediumSize[i].id = i;
    }

    return allImages;
  } else if (
    getEnhancedProductData &&
    getEnhancedProductData.Series &&
    getEnhancedProductData.Series.Images != null &&
    getEnhancedProductData.Series.Images.Thumbs.length > 0
  ) {
    let allImages = getEnhancedProductData.Series.Images;

    if (
      getEnhancedProductData.Series &&
      getEnhancedProductData.Series.Videos != null &&
      getEnhancedProductData.Series.Videos.Thumbs.length > 0
    ) {
      // Large Size
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.LargeSize.length;
        i++
      ) {
        allImages.LargeSize.push(
          getEnhancedProductData.Series.Videos.LargeSize[i]
        );
      }
      // Thumbs
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.Thumbs.length;
        i++
      ) {
        allImages.Thumbs.push(getEnhancedProductData.Series.Videos.Thumbs[i]);
      }

      // Normal Size
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.NormalSize.length;
        i++
      ) {
        allImages.NormalSize.push(
          getEnhancedProductData.Series.Videos.NormalSize[i]
        );
      }

      // Medium Size
      for (
        let i = 0;
        i < getEnhancedProductData.Series.Videos.MediumSize.length;
        i++
      ) {
        allImages.MediumSize.push(
          getEnhancedProductData.Series.Videos.MediumSize[i]
        );
      }
    }

    for (let i = 0; i < allImages.Thumbs.length; i++) {
      allImages.Thumbs[i].id = i;
    }
    for (let i = 0; i < allImages.NormalSize.length; i++) {
      allImages.NormalSize[i].id = i;
    }
    for (let i = 0; i < allImages.LargeSize.length; i++) {
      allImages.LargeSize[i].id = i;
    }
    for (let i = 0; i < allImages.MediumSize.length; i++) {
      allImages.MediumSize[i].id = i;
    }

    return allImages;
  }

  /**
        If we reach this point there is no main image and we need to provide a fallback
       **/
  const defaultImage = {
    Url:
      "https://res.cloudinary.com/avd/image/upload/v1576013897/ProductPage/General/No-Image.jpg",
    Title: "No Photo Available"
  };
  if (imagesFrom == "bom") {
    return {};
  } else {
    return {
      Thumbs: [defaultImage],
      NormalSize: [defaultImage],
      LargeSize: [defaultImage]
    };
  }
}

export function bomImagesTransformation(allImages) {
  for (let i = 0; i < allImages.Thumbs.length; i++) {
    allImages.Thumbs[i].id = i;
  }
  for (let i = 0; i < allImages.NormalSize.length; i++) {
    allImages.NormalSize[i].id = i;
  }
  for (let i = 0; i < allImages.LargeSize.length; i++) {
    allImages.LargeSize[i].id = i;
  }
  for (let i = 0; i < allImages.MediumSize.length; i++) {
    allImages.MediumSize[i].id = i;
  }

  return allImages;
}
